/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Order_Item_Quantity_DecreaseInputs */

const vi_pos_order_item_quantity_decrease = /** @type {(inputs: Pos_Order_Item_Quantity_DecreaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm số lượng`)
};

/**

* @param {Pos_Order_Item_Quantity_DecreaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_order_item_quantity_decrease = /** @type {((inputs?: Pos_Order_Item_Quantity_DecreaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Order_Item_Quantity_DecreaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_order_item_quantity_decrease(inputs)
});